// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"MediaEmbed_videoEmbed__2h2R6","audioEmbed":"MediaEmbed_audioEmbed__2dcOk","tweetEmbed":"MediaEmbed_tweetEmbed__3M63J"};